import { render, staticRenderFns } from "./ObsView.vue?vue&type=template&id=31c728af&scoped=true"
import script from "./ObsView.vue?vue&type=script&lang=js"
export * from "./ObsView.vue?vue&type=script&lang=js"
import style0 from "./ObsView.vue?vue&type=style&index=0&id=31c728af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c728af",
  null
  
)

export default component.exports